import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  PageInfo,
  PermissionsEnum,
  SchedulerQuery,
  SchedulerQueryDataOut,
  SchedulerStatus,
  SortingType,
} from '../../../../api/api-reference';
import { AuthService } from '../../../../services/auth.service';
import { SearchComponent } from '../../../core/components/search/search.component';
import { SortComponent } from '../../../core/components/sort/sort.component';
import { PaginationComponent } from '../../../core/components/pagination/pagination.component';
import { SchedulerDetailsComponent } from '../scheduler-details/scheduler-details.component';
import { ConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-scheduler-management',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    SearchComponent,
    PaginationComponent,
    SortComponent,
    SchedulerDetailsComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './scheduler-management.component.html',
  styleUrl: './scheduler-management.component.scss',
})
export class SchedulerManagementComponent implements OnInit {
  public pageSize: number = 5;
  public pageNumber: number = 1;
  public currentPage: number = 1;
  public numberOfReminders: number = 0;
  public lastPageSize: number = 1;
  isModalOpen = false;
  public selectedReminder: SchedulerQueryDataOut | undefined;
  selectedRowId: string | null = null;
  activeRow: number | null = null;
  reminderData: SchedulerQueryDataOut[] | undefined = [];
  requestData = new SchedulerQuery({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    search: undefined,
    sorting: SortingType.Descending,
  });

  reminderStatus: SchedulerStatus = new SchedulerStatus();

  public colorMap: { [key: string]: string } = {};
  public PermissionsEnum = PermissionsEnum;

  constructor(
    private toastr: ToastrService,
    public router: Router,
    public client: Client,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.reloadTable(1);
  }

  onSortOption(selectedSort?: SortingType) {
    if (selectedSort) this.requestData.sorting = selectedSort;
    this.reloadTable();
  }

  searchChange(searchText: string) {
    this.requestData.search = searchText;
    this.reloadTable(1);
  }

  reloadTable(page?: number) {
    this.pageNumber = page || 0;
    if (page) this.requestData!.pageInfo!.page = this.pageNumber;

    this.isModalOpen = false;
    this.selectedReminder = undefined;

    this.client.queryReminders(this.requestData).subscribe({
      next: (response) => {
        this.reminderData = response.data;
        this.numberOfReminders = response.count || 0;
        this.lastPageSize = Math.ceil(this.numberOfReminders / this.pageSize);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  pageChange(value: number) {
    this.currentPage = value;
    this.reloadTable(this.currentPage);
  }

  handleRowClickReminder(row: SchedulerQueryDataOut) {
    if (!this.isModalOpen) this.selectedReminder = row;
    else this.selectedRowId = row.id!;
  }

  setActiveRow(rowIndex: number | null) {
    this.activeRow = this.activeRow === rowIndex ? null : rowIndex;
  }

  editReminder(id: string) {
    this.router.navigate(['settings/scheduler/schedule-setup'], {
      state: { reminderData: id },
    });
  }

  showMonitoring(id: string) {
    this.router.navigate(['settings/scheduler/monitoring'], {
      state: { monitoringId: id },
    });
  }

  changeStatus(id: string, isActive: boolean) {
    this.reminderStatus.reminderId = id;
    this.reminderStatus.isActive = isActive;

    this.client.reminderStatus(this.reminderStatus).subscribe({
      next: () => {
        this.toastr.success('Reminder successfuly changed status.');
        this.reloadTable();
        this.setActiveRow(null);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  delete(id: string) {
    this.client.deleteReminder(id).subscribe({
      next: () => {
        this.toastr.success('Reminder successfuly deleted.');
        this.reloadTable();
        this.setActiveRow(null);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
